import { gql, useQuery } from '@apollo/client';
import React from 'react';
import type {
  TemplateMenuItemRow_TemplatePostFragment,
  TemplateMenuItemRowTemplatePostQuery,
  TemplateMenuItemRowTemplatePostQueryVariables,
} from '../graphql/generated/graphqlTypes';
import TemplateRow from './TemplateRow';

const TEMPLATE_MENU_ITEM_ROW_TEMPLATE_POST_FRAGMENT = gql`
  fragment TemplateMenuItemRow_templatePost on Post {
    id
    ...TemplateRow_templatePost
  }
  ${TemplateRow.fragments.templatePost}
`;

const TEMPLATE_MENU_ITEM_ROW_TEMPLATE_POST_QUERY = gql`
  query TemplateMenuItemRowTemplatePost($id: ID!) {
    post(id: $id) {
      id
      ...TemplateMenuItemRow_templatePost
    }
  }

  ${TEMPLATE_MENU_ITEM_ROW_TEMPLATE_POST_FRAGMENT}
`;

type TemplatePostMenuItemRowProps =
  | { templateId: string; template?: never }
  | { templateId?: never; template: TemplateMenuItemRow_TemplatePostFragment };

const TemplatePostMenuItemRow = ({
  templateId,
  template,
}: TemplatePostMenuItemRowProps) => {
  const { data } = useQuery<
    TemplateMenuItemRowTemplatePostQuery,
    TemplateMenuItemRowTemplatePostQueryVariables
  >(TEMPLATE_MENU_ITEM_ROW_TEMPLATE_POST_QUERY, {
    variables: { id: templateId as string },
    skip: !templateId,
  });

  const templateItem = data?.post ?? template;

  return templateItem ? (
    <TemplateRow
      template={templateItem}
      link="detail"
      padding="small"
      showHoverCard
    />
  ) : null;
};

type TemplateMenuItemRowProps =
  | { templateId: string; template?: never }
  | { templateId?: never; template?: TemplateMenuItemRow_TemplatePostFragment };

const TemplateMenuItemRow = (props: TemplateMenuItemRowProps) => {
  return (
    <TemplatePostMenuItemRow {...(props as TemplatePostMenuItemRowProps)} />
  );
};

TemplateMenuItemRow.fragments = {
  templatePost: TEMPLATE_MENU_ITEM_ROW_TEMPLATE_POST_FRAGMENT,
};

export default TemplateMenuItemRow;
